import { render, staticRenderFns } from "./the-common-settings-dialog.vue?vue&type=template&id=312cbc08&scoped=true&"
import script from "./the-common-settings-dialog.vue?vue&type=script&lang=js&"
export * from "./the-common-settings-dialog.vue?vue&type=script&lang=js&"
import style0 from "./the-common-settings-dialog.vue?vue&type=style&index=0&id=312cbc08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312cbc08",
  null
  
)

export default component.exports